// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__FV28D","orgMain":"Layout_orgMain__jDMdx","content":"Layout_content__UOgH6","orgContent":"Layout_orgContent__lKd5b"};